import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const TOMOS = [{
  title: 'Tomo 1 — Entiende tu mente',
  desc: 'Descubre por qué la mente genera sobrepensamiento y cómo empezar a reducirlo.'
}, {
  title: 'Tomo 2 — Observa tus pensamientos',
  desc: 'Aprende a observar los pensamientos sin reaccionar automáticamente.'
}, {
  title: 'Tomo 3 — Domina tu mundo interior',
  desc: 'Desarrolla estabilidad mental y control emocional.'
}, {
  title: 'Tomo 4 — El camino hacia la verdadera paz mental',
  desc: 'La enseñanza final para vivir con una mente más tranquila y clara.'
}];
export function IncludesSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 px-4 bg-cream-alt" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-111">
            Dentro del Mega Pack Claridad Mental encontrarás
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-6" data-id="element-112">
          {TOMOS.map((tomo, index) => <motion.div key={index} variants={itemVariants} className="bg-cream p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-gold-start flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-113">
              <div className="bg-cream-alt p-4 rounded-full shrink-0" data-id="element-114">
                <BookOpen className="w-8 h-8 text-gold-end" data-id="element-115" />
              </div>
              <div data-id="element-116">
                <h3 className="text-xl md:text-2xl font-bold text-brown mb-2" data-id="element-117">
                  {tomo.title}
                </h3>
                <p className="text-lg text-brown-light" data-id="element-118">{tomo.desc}</p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}